import * as MapLibreGL from "maplibre-gl";
import workerUrl from "maplibre-gl/dist/maplibre-gl-worker.mjs?url";

// MapLibre 6 loads its worker from a file next to the library module, which
// Vite never emits. Point it at the asset Vite does emit (base path included).
// Every map goes through ./map, so this runs before the first `new Map`.
MapLibreGL.setWorkerUrl(workerUrl);